import React, { PureComponent } from 'react'
import { renderToString } from 'react-dom/server'
import BEMHelper from '@ynap/bem-helper'
import EmptyList from '@ynap/empty-list'

const bem = new BEMHelper('GiftCards')

/**
 * Renders anchor for telephone to string
 * @param {Object} props
 * @returns {VDOM}
 */
const PhoneLink = ({ number, className }) => (
    <a dir="ltr" href={`tel:${number}`} className={className}>
        {number}
    </a>
)

class GiftCards extends PureComponent {
    constructor() {
        super()
        this.state = { countryPhone: '' }
    }

    componentDidMount() {
        const { telephone: countryPhone } = window.SF?.getContactDetails?.()?.customerCare || {}
        this.setState({ countryPhone })
    }

    render() {
        const { messages } = this.props
        const { countryPhone } = this.state

        const countryPhoneLink = renderToString(<PhoneLink number={countryPhone} className={bem('link')} />)

        return (
            <div className={bem('container')}>
                <EmptyList
                    className={bem('emptyState')}
                    title={messages.giftcards.title()}
                    icon={<div className={bem('emptyStateIcon')} />}
                    variant={'Credit'}
                >
                    <p className={bem('label')}>{messages.giftcards.noGiftCard()}</p>
                </EmptyList>
                <p
                    className={bem('info')}
                    dangerouslySetInnerHTML={{ __html: messages.giftcards.info({ countryPhoneLink }) }}
                ></p>
            </div>
        )
    }
}

export default GiftCards
